const ADJUST_URL = 'https://app.adjust.net.in';
const IMAGE_FILE_SIZE_LIMIT = 30000000;
const IMAGE_FILE_SIZE_LIMIT_VIOLATED_MESSAGE =
  'File size must be less than 30 MB';
const IMAGE_FILE_FAILED_TO_UPLOAD_MESSAGE = 'Failed to upload a image.';

export {
  ADJUST_URL,
  IMAGE_FILE_SIZE_LIMIT,
  IMAGE_FILE_SIZE_LIMIT_VIOLATED_MESSAGE,
  IMAGE_FILE_FAILED_TO_UPLOAD_MESSAGE,
};
